var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_1384)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.2832,
    cy: 4.67871,
    r: 4.67871,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0547 20C19.0547 17.6735 18.1305 15.4423 16.4854 13.7973C14.8404 12.1522 12.6092 11.228 10.2827 11.228C7.95624 11.228 5.72506 12.1522 4.07999 13.7973C2.43493 15.4423 1.51074 17.6735 1.51074 20L10.2827 20H19.0547Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c1951ce0c86a0c4dcb71786ff6f69231.svg";
export { ForwardRef as ReactComponent };